// extracted by mini-css-extract-plugin
export default {"container":"check-table-cell_container__iHF9A"};